import React, { useState } from "react";
import "./login.css";
import { Form, Button, InputGroup, Modal, Container } from "react-bootstrap";
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import { useAuth } from "../../contexts/AuthProvider";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate } from "react-router-dom";

import JHF from "../../imgs/jhf-sem-fundo.png";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleCloseErrorModal = () => {
    setShowErrorModal(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (email.trim() === "") {
      setEmailError("Por favor, preencha o campo de email");
      return;
    } else {
      setEmailError("");
    }

    if (password.trim() === "") {
      setPasswordError("Por favor, preencha o campo de senha");
      return;
    } else {
      setPasswordError("");
    }

    try {
      setLoading(true);
      const userData = await login(email, password);
      navigate("/home");
    } catch (error) {
      console.error("Erro:", error);
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="mb-3 text-center">
          <img src={JHF} alt={JHF} className="img-fluid" />
        </div>
        <div className="card card-outline card-primary">
          <div className="card-header">
            <h4 className="mb-0 text-center">
              <b>Login</b>
            </h4>
          </div>
          <div className="card-body login-card-body">
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>E-mail</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                />
                {emailError && <div className="text-danger">{emailError}</div>}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Senha:</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={handlePasswordChange}
                  />
                  <Button
                    variant="secondary"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <BsFillEyeSlashFill /> : <BsFillEyeFill />}
                  </Button>
                </InputGroup>
                {passwordError && (
                  <div className="text-danger">{passwordError}</div>
                )}
              </Form.Group>
              <Button
                type="submit"
                variant="primary"
                className="w-100"
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                ) : (
                  "Entrar"
                )}
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;